import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";
import {OfferKmId} from "@/types/ids";

interface IInvestmentInquiriesState {
    sentInvestmentIds: OfferKmId[];
}

const INITIAL_STATE: IInvestmentInquiriesState = {
    sentInvestmentIds: []
};

/**
 * Inquiries sent in this session, remembered so the CTA stays spent after the component that sent it is
 * gone - the tile re-renders from a refetch, the gallery panel unmounts with the modal.
 */
export const investmentInquiriesSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "investmentInquiries",
    reducers: {
        markInvestmentInquirySent: (state, action: PayloadAction<OfferKmId>) => {
            if (state.sentInvestmentIds.includes(action.payload)) return;

            state.sentInvestmentIds.push(action.payload);
        }
    }
});

export const {markInvestmentInquirySent} = investmentInquiriesSlice.actions;

export const selectIsInvestmentInquirySent = (investmentId: OfferKmId) => (state: RootState) =>
    state.investmentInquiries.sentInvestmentIds.includes(investmentId);
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {RootState} from "@/store/types/RootState";
import {OfferKmId} from "@/types/ids";

interface IInvestmentInquiriesState {
    sentInvestmentIds: OfferKmId[];
}

const INITIAL_STATE: IInvestmentInquiriesState = {
    sentInvestmentIds: []
};

/**
 * Inquiries sent in this session, remembered so the CTA stays spent after the component that sent it is
 * gone - the tile re-renders from a refetch, the gallery panel unmounts with the modal.
 */
export const investmentInquiriesSlice = createSlice({
    initialState: INITIAL_STATE,
    name: "investmentInquiries",
    reducers: {
        markInvestmentInquirySent: (state, action: PayloadAction<OfferKmId>) => {
            if (state.sentInvestmentIds.includes(action.payload)) return;

            state.sentInvestmentIds.push(action.payload);
        }
    }
});

export const {markInvestmentInquirySent} = investmentInquiriesSlice.actions;

export const selectIsInvestmentInquirySent = (investmentId: OfferKmId) => (state: RootState) =>
    state.investmentInquiries.sentInvestmentIds.includes(investmentId);
